import { ProductAttributes } from "../../hooks/useStandardProducts";
import { TemplateArtifact } from "../../utils/templateApi.util";
import { ATTRIBUTES } from "./attributeHelpers";
import { getDisplayName } from "./attributeValueMappings";

// Human-readable spec label for a template footer, built from the same attribute-to-label mapping the
// details drawer uses. Covers name trim size, paper, and bind; pages name trim size and bind. Pair
// with `composeProductDescription` to append the page count.
export function composeProductSpecLabel(artifact: TemplateArtifact, attributes: ProductAttributes): string {
  const label = (key: string): string | undefined => {
    const value = attributes[key];
    return value !== undefined ? getDisplayName(key, String(value)) : undefined;
  };

  const paper = [label(ATTRIBUTES.TEXT_STOCK), label(ATTRIBUTES.STOCK_STYLE)].filter(Boolean).join(" ");

  const parts =
    artifact === "cover"
      ? [label(ATTRIBUTES.DIMENSIONS), paper || undefined, label(ATTRIBUTES.BIND_TYPE)]
      : [label(ATTRIBUTES.DIMENSIONS), label(ATTRIBUTES.BIND_TYPE)];

  return parts.filter(Boolean).join(" | ");
}
